class ApiConfig {
    get orbisToken() {
        return 'orbisToken';
    }

    get middlewareToken() {
        return 'middlewareToken';
    }

    get apiUrl() {
        return import.meta.env.RIA_API_URL || '';
    }

    get watchmenInstance() {
        return new URL(this.apiUrl).hostname;
    }

    get middlewareUrl() {
        return import.meta.env.RIA_MIDDLEWARE_URL || '';
    }

    get umaApiUrl() {
        return import.meta.env.RIA_UMA_API_URL || '';
    }

    get umaFirmId() {
        return import.meta.env.RIA_UMA_FIRM_ID || '';
    }

    get umaAuthFormSlug() {
        return import.meta.env.RIA_UMA_AUTH_FORM_FIRM_SLUG || '';
    }

    get googleMapKey() {
        return import.meta.env.RIA_GOOGLE_MAPS_KEY || '';
    }

    get usersnapSpaceApiKey() {
        return import.meta.env.RIA_USERSNAP_SPACE_API_KEY || '';
    }

    get usersnapProjectApiKey() {
        return import.meta.env.RIA_USERSNAP_PROJECT_API_KEY || '';
    }

    get sentryUrl() {
        return import.meta.env.RIA_SENTRY_URL || '';
    }

    get sentryOrg() {
        return import.meta.env.RIA_SENTRY_ORG || '';
    }

    get sentryProject() {
        return import.meta.env.RIA_SENTRY_PROJECT || '';
    }

    get sentryDns() {
        return import.meta.env.RIA_SENTRY_DSN || '';
    }

    get sentryToken() {
        return import.meta.env.RIA_SENTRY_TOKEN || '';
    }

    get sentrySampleRate() {
        return Number(import.meta.env.RIA_SENTRY_SAMPLE_RATE || '0.5');
    }
}

const apiConfig = new ApiConfig();

export { apiConfig };
